/** Demo / sample-data mode. Production builds should keep this unset or `false`. */
export function isDemoMode(): boolean {
  return import.meta.env["VITE_DEMO_MODE"] === "true";
}
